import React from 'react';
import './index.scss';
import TextInfo from '@bit/gerenciatd.unifiedcomponents.text-info';
import CustomLink from '@bit/gerenciatd.unifiedcomponents.custom-link';
import Button from '@bit/gerenciatd.unifiedcomponents.button';

export const COMPONENT_NAME = 'Servicing';

const ServicingSection = (servicingInfo) => {
  const {
    'Button-list': buttonList,
    'TextInfo-title': title,
  } = servicingInfo;

  const taggingInfo = {
    ...servicingInfo.taggingInfo,
    componentProduct: '',
    componentVariation: 'all',
    componentName: COMPONENT_NAME,
  }

  return (
    <section className="Servicing-section">
      <TextInfo {...title} />
      <ul className="Servicing-section__list">
        {buttonList && buttonList.list.map(button => (
          <Button
            taggingInfo={{
              ...taggingInfo,
              componentContent: button.label,
            }}
            {...button}
            {...buttonList.props}
          />
        ))}
      </ul>
    </section>
  );
};

export default ServicingSection;
